import { render, staticRenderFns } from "./CreateFakeUser.vue?vue&type=template&id=207c23fa&scoped=true"
import script from "./CreateFakeUser.vue?vue&type=script&lang=js"
export * from "./CreateFakeUser.vue?vue&type=script&lang=js"
import style0 from "./CreateFakeUser.vue?vue&type=style&index=0&id=207c23fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c23fa",
  null
  
)

export default component.exports